<template>
    <div>
        <div style="background-color: rgb(245, 245, 245); padding: 15px">
            <search-form :filterSet="filterSet" v-model="filterForm" @search="getTableData"></search-form>
        </div>
        <mume-table ref="ctable" :searchForm="filterForm" :callback="table.callback" :api="table.api" :column="table.column"
            :batchAction="batchAction" :rowAction="rowAction">
            <template slot-scope="scope">
                <el-button @click.native.prevent="detail(scope.rowData)" type="text" size="small">详情</el-button>
                <el-button @click.native.prevent="deleteData(scope.rowData)" type="text" size="small">删除</el-button>
            </template>
        </mume-table>
        <notice-lapyer ref="noticeLapyer" @onSubmitCallback="getTableData"></notice-lapyer>
    </div>
</template>
<script>
import util from '../../utils/utils'
import mumeTable from "../plugin/mume-table.vue";
import NoticeLapyer from './notice-lapyer.vue';

export default {
    components: { mumeTable, NoticeLapyer },
    data() {
        return {
            filterSet: {
                showExport: false,
                fields: [
                    {
                        label: "搜索标题",
                        key: "title",
                        placeholder: "请输入",
                        type: "text",
                    },
                    {
                        label: "通知类型",
                        key: "type",
                        placeholder: "请选择",
                        type: "select",
                        optionName: "name",
                        optionValue: "value",
                        options: [{ name: '系统通知', value: 1 }, { name: '弹窗', value: 2 }],
                    },
                    {
                        label: "通知对象",
                        key: "groupId",
                        placeholder: "请输入组Id，0代表全部",
                        type: "text",
                    },
                    { label: "发布时间", key: "times", type: "date-picker" },
                ],
            },
            filterForm: {
                title: undefined,
                groupId: undefined,
                type: undefined,
                startTime: undefined,
                endTime: undefined,
                times: []
            },
            batchAction: [{ text: "新建群发", action: this.gotoAdd, type: "primary" },
            { text: "删除", action: this.batchDelete }],
            rowAction: { label: "操作", width: 120, fixed: "right" },
            tableData: [],
            tableLoading: false,
            table: {
                api: "api/platform/getSysNoticeByPage",
                callback: (res, data) => {
                    if (res.data.obj) {
                    }
                },
                column: [
                    {
                        label: "通知类型", name: "type", formatter: (r) => {
                            if (r.type == 1) {
                                return "系统通知"
                            }
                            if (r.type == 2) {
                                return "弹窗"
                            }
                        }
                    },
                    { label: "通知标题", name: "title" },
                    { label: "发布时间", name: "publishTime" },
                    {
                        label: "通知对象", name: "groupId", formatter: (r) => {
                            if (!r.groupId)
                                return '全部'
                            return r.groupId
                        }
                    },
                    { label: "操作用户", name: "operateName" },
                    { label: "曝光量", name: "orderNum" },
                ],
            },
        }
    },
    methods: {
        getTableData() {
            this.tableLoading = true;
            let data = Object.assign({}, this.filterForm);
            if (this.filterForm.times && this.filterForm.times.length > 0) {
                this.filterForm.startTime = this.filterForm.times[0];
                this.filterForm.endTime = this.filterForm.times[1];
            }
            this.$refs.ctable.getData();
        },
        gotoAdd() {
            this.$refs.noticeLapyer.open()
        },
        batchDelete() { },
        detail(row) {
            this.$refs.noticeLapyer.open(Object.assign({}, row))
        },
        deleteData(row) {
            this.$confirm("删除后不可恢复，确定要删除通知吗？", "删除提示").then(() => {
                this.$httpRequest.get('api/platform/deleteSysNoticeById', { id: row.id }).then(res => {
                    this.$message.success('操作成功');
                    this.$refs.ctable.getData();
                });
            })
        }
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/system/notice.vue